import React from "react";
import { useContext} from "react";
import { store } from "../../../Store";
import { useLanguageVisibility } from "../../../language/hooks/use-language-visibility";
import { useLanguage } from "../../../../hooks/use-language";
import { useLanguageSelection } from "../../../../hooks/use-language-selection";
import { FocusScope } from "react-aria";
import { useTranslationsById } from "../../../../hooks/use-translations-by-id";

/**
 * Rederiza el dropdown de lenguaje
 * @param {Function} visibility -funcion que se encarga de cerrar o abrir el dropdown
 * @returns {React.Component} -DropdownLang
 */
export const Drop = ({visibility}) => {
    const storeContext = useContext(store);
    const appState = storeContext?.state;
    const language = useLanguage();
    const languageSelection = useLanguageSelection();
    const isVisible = appState?.languageDropdown?.visible;
    const languageVisibility = useLanguageVisibility();
    const texts = useTranslationsById({ mainSectionName: "header", language: language });

    const updateLanguage = (lang) => {
        languageSelection.setLanguage({lang});
        localStorage.setItem('language', lang);
        if (languageVisibility.isVisible) {
            storeContext.dispatch({
                type: "CHANGE",
                path: "languageDropdown.visible",
                value: false,
            });
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === "Escape") {
            visibility();
        }
    };

    return (
        isVisible && (
            <FocusScope contain restoreFocus autoFocus>
                <ul className={`dropdownLang  ${isVisible ? 'activeMode' : 'inactiveMode'} `} onKeyDown={handleKeyDown}>
                    <li className={`${isVisible ? 'activeMode' : 'inactiveMode'}`}>
                        <button
                            className={`button focusable-red ${language === "es" ? "activeMode" : "inactiveMode"}`}
                            onClick={() => {updateLanguage("es")}}
                            aria-pressed={language === "es" ? true : false}
                        >
                            Español
                        </button>
                    </li>
                    <li className={`${isVisible ? 'activeMode' : 'inactiveMode'}`}>
                        <button
                            className={`button focusable-red ${language === "en" ? "activeMode" : "inactiveMode"}`}
                            onClick={() => updateLanguage("en")}
                            aria-pressed={language === "en" ? true : false}
                        >
                            English
                        </button>
                    </li>
                    <li className={`option-close`}>
                        <button
                            onClick={() => visibility()}
                            aria-label={texts?.getText({ id:"button_close_list_alt", defaultText: "Cerrar la lista desplegable"}) }
                            className="focusable-red button-close"
                        >
                            {texts?.getText({ id:"button_close_list", defaultText: "Cerrar"})}
                        </button>
                    </li>
                </ul>
            </FocusScope>
        )
    )
}